import { HznBadge } from '@horizon/badge';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Container from '@mui/material/Container';
import { useFeatureFlags } from '@shared/hooks/useFeatureFlag';
import useMsalUser from '@shared/hooks/useMsalUser';
import logClickEvent from '@shared/utilities/event-logging';
import { NavLink } from 'react-router-dom';

import styles from './SubHeader.module.scss';

export default function SubHeader() {
    const applyActiveLinkClass = ({ isActive }) => (isActive ? styles['active-link'] : undefined);
    const { isAuthenticated } = useMsalUser();
    const flags = useFeatureFlags();

    if (!isAuthenticated) {
        return <span data-testid="sub-header"></span>;
    }

    return (
        <Box className={styles['sub-header']} data-testid="sub-header">
            <Container className={styles['sub-header-container']}>
                <NavLink
                    to="/memberdashboard"
                    className={applyActiveLinkClass}
                    onClick={() => {
                        logClickEvent('My Auctions', 'SubHeader');
                    }}>
                    My Auctions
                </NavLink>
                <NavLink
                    to="/mytransactions"
                    className={applyActiveLinkClass}
                    onClick={() => {
                        logClickEvent('My Transactions', 'SubHeader');
                    }}>
                    My Transactions
                </NavLink>
                <NavLink
                    to="/saved-searches"
                    className={applyActiveLinkClass}
                    onClick={() => {
                        logClickEvent('Saved Searches', 'SubHeader');
                    }}>
                    Saved Searches
                </NavLink>
                <NavLink
                    to="/mylist"
                    className={applyActiveLinkClass}
                    onClick={() => {
                        logClickEvent('My List', 'SubHeader');
                    }}>
                    My List
                </NavLink>
                <NavLink
                    to="/myprofile"
                    className={applyActiveLinkClass}
                    onClick={() => {
                        logClickEvent('My Profile', 'SubHeader');
                    }}>
                    My Profile
                </NavLink>
                {flags?.brokerageShowTimedAuctions ? (
                    <NavLink
                        to="/timed-auctions"
                        className={applyActiveLinkClass}
                        onClick={() => {
                            logClickEvent('Timed Auctions', 'SubHeader');
                        }}>
                        Timed Auctions{' '}
                        <hzn-badge label="New" tone="info" style={{ marginLeft: 5 }}></hzn-badge>
                    </NavLink>
                ) : null}
            </Container>
        </Box>
    );
}
